import React from 'react';

import styled from '@emotion/styled';

import { TermsAndConditionsCompleteData } from '../../../hooks/useTermsAndConditions';
import Button from '../../Button/Button';
import { LegalContent } from '../../LegalContent/LegalContent';
import BaseDialog, { BaseDialogProps } from '../Base';

type Props = {
  showAgreementsButtons?: boolean;
  onAgreePolicy: (val: boolean) => void;
  termsData: TermsAndConditionsCompleteData;
} & BaseDialogProps;

export const PrivacyPolicyDialog: React.FC<Props> = ({
  showAgreementsButtons,
  termsData: { isLoading, privacy, updateDate },
  onAgreePolicy,
  onClose,
  ...rest
}) => {
  const [isPolicyRead, setIsPolicyRead] = React.useState(false);

  const onPolicyReadHandle = () => {
    setIsPolicyRead(true);
  };

  const onPolicyHandle = () => {
    onAgreePolicy(isPolicyRead);
  };

  return (
    <BaseDialog
      width='940px'
      minHeight='700px'
      titleComponent={<ModalTitle>Privacy Policy</ModalTitle>}
      padding='14px 10px'
      showCloseIcon={false}
      {...rest}
    >
      <TermsContainer>
        {isLoading && <p>Loading...</p>}
        {privacy && (
          <LegalContent
            content={privacy}
            updateDate={updateDate || ''}
            isTermsRead={isPolicyRead}
            onTermsRead={onPolicyReadHandle}
          />
        )}
      </TermsContainer>
      <Footer maxWidth={showAgreementsButtons ? '75%' : '37.5%'}>
        <Button
          variant='outlined'
          fullWidth
          sx={{ borderRadius: '8px', py: 1.5 }}
          onClick={onClose}
        >
          Cancel
        </Button>
        {showAgreementsButtons && (
          <Button
            variant='contained'
            fullWidth
            sx={{ borderRadius: '8px', py: 1.5 }}
            disabled={isLoading || !isPolicyRead}
            onClick={onPolicyHandle}
          >
            I Agree
          </Button>
        )}
      </Footer>
    </BaseDialog>
  );
};

const ModalTitle = styled.h1`
  color: #000;
  font-size: 28px;
  font-weight: 500;
  margin: 0 0 10px 0;
  padding: 0;
`;

const TermsContainer = styled.div`
  border-radius: 6px;
  background-color: #f8f8f8;
  padding: 25px;
  height: 85%;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-track {
    background: #e9e9e9;
    border-radius: 6px;
    margin: 5px 0;
  }

  ::-webkit-scrollbar-thumb {
    background: #121212;
    border-radius: 8px;
  }
`;

const Footer = styled.div<{ maxWidth?: string }>`
  margin-top: 34px;
  width: ${(props) => props.maxWidth || '75%'};

  display: flex;
  align-items: center;
  gap: 18px;
`;
